import { useRef, useState } from "react";
import { Input } from "reactstrap";

const SliderInput = ({ value, setValue, min, max, unitValue }) => {
  const [sliderPosition, setSliderPosition] = useState(0);

  const updatePosition = (inputElement) => {
    if (inputElement) {
      const rangeInput = inputElement;
      const inputValue = Number(inputElement?.value);
      const rangeWidth = rangeInput?.offsetWidth;
      const thumbWidth = 30; // Assuming thumb width is 30px
      const valueRatio = (inputValue - min) / (max - min);
      const position = valueRatio * (rangeWidth - thumbWidth);
      setSliderPosition(position);
    }
  };

  return (
    <div className="position-relative">
      <Input
        value={value}
        onChange={(e) => {
          setValue(e?.target?.value);
          updatePosition(e?.target);
        }}
        min={min}
        max={max}
        type="range"
      />
      <div className="d-flex justify-content-between align-items-center">
        <span className="d-block">
          {min} {unitValue}
        </span>
        <span className="d-block">
          {max} {unitValue}
        </span>
      </div>
      <span
        style={{
          left: sliderPosition + "px",
          top: "57%",
        }}
        className="color-primary-blue f-6 d-block position-absolute"
      >
        {value} {unitValue}
      </span>
    </div>
  );
};

export default SliderInput;
